import React from 'react';
import PropTypes from 'prop-types';
import timePropTypes from '../../../propTypes/entities/time';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('dailyPlanning');

const StatCounter = props => {
  const { value, text } = props;

  const defaultValue = 0;
  let shouldDisplay = true;

  if (value.hours === 0 && value.minutes === 0) {
    shouldDisplay = false;
  }

  return (
    <div className="dash-panel bgm-allo-trans">
      {shouldDisplay ? (
        <div className="main-stat">
          <span className="stat">{value.hours || 0}</span>
          <span className="stat-type">{locale.getMsg('hour')}</span>
          <span className="stat">{value.minutes || 0}</span>
          <span className="stat-type">{locale.getMsg('minute')}</span>
        </div>
      ) : (
        <div className="main-stat">
          <span className="stat">{defaultValue || 0}</span>
          <span className="stat-type">{locale.getMsg('hour')}</span>
        </div>
      )}
      <div className="stat-label">{text}</div>
    </div>
  );
};

StatCounter.propTypes = {
  value: timePropTypes.isRequired,
  text: PropTypes.string.isRequired,
};

export default StatCounter;
